import React from 'react';
import { Icons, Header, Link, Button, Image, NoWrap } from 'components';
import { config } from 'helpers';
import css from './hero.scss';

export function Hero(props) {
  return (
    <div className={css.hero}>

      <Image.Loader src={require('./hero.jpg')} onLoad={props.setReady} />

      <Image className={[css.background, props.status].join(' ')} src={require('./hero.jpg')} />

      <Header.Compensate ref={props.refHeaderBreakpoint} />

      <div className={css.relative}>
        <h1>Discover Your Personal <NoWrap>Success Formula</NoWrap></h1>
        <div className={css.container}>
          <p>Life coaching is about closing the gap between where you are today and where you want to be. It is about self-awareness, guided exploration, and commitment to change and personal growth. Online life coaching is for people that are looking to get more out of life and make more out of themselves.</p>
          <ul className={[css.list, props.status].join(' ')}>
            <li><Icons.Check />What would living life to the fullest mean to you?</li>
            <li><Icons.Check />Can you imagine how great it feels living a totally fulfilling and authentic life?</li>
            <li><Icons.Check />What's it going to be like when you achieve your most important life goals?</li>
            <li><Icons.Check />What does it mean to you to enjoy life with purpose, passion and prosperity?</li>
          </ul>
          <p>Success Wizard is all about helping people achieve greater levels of Success and Satisfaction in their personal and professional lives. </p>
          <p>
            <Link to="/sign-up/?redirect=/settings/membership/" className={css.relative}>
              <Button className={[css.button, props.status].join(' ')}>{ config.trialPeriod }</Button>
              <span>Start { config.trialPeriod }</span>
            </Link>
          </p>
        </div>
      </div>

    </div>
  );
}

